var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-row',[_c('vs-col',{attrs:{"vs-offset":"4","vs-type":"flex","vs-justify":"center","vs-align":"center","vs-w":"4"}},[_c('Form',{attrs:{"isRRHH":_vm.isRRHH}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }